// ** Kameralar
const initialGps = {}

const gps = (state = initialGps, action) => {
  switch (action.type) {
    case "SET_GPS_TYPES_CONTENT":
      return { ...state, ...action.val }
    default:
      return state
  }
}

export default gps
